import { NgModule } from '@angular/core';
import { S110gS110m01Component } from './s110g-s110m01.component';
import { S110gS110m02Component } from './s110g-s110m02.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [S110gS110m01Component,
		S110gS110m02Component]
})
export class S110gModule { }

